import React from 'react';
import { Link } from 'react-router-dom';
import { DELIVERY_ZONES } from './deliveryRules';

const CENTER_REGIONS = [
    'Белгородская', 'Брянская', 'Владимирская', 'Воронежская', 'Ивановская',
    'Калужская', 'Костромская', 'Курская', 'Липецкая', 'Орловская',
    'Рязанская', 'Смоленская', 'Тамбовская', 'Тверская', 'Тульская', 'Ярославская',
];

const DeliveryPage = () => (
    <div className="max-w-4xl mx-auto py-12 px-4">
        <h1 className="serif text-4xl md:text-5xl text-[#1C1917] mb-4 text-center">Оплата и доставка</h1>
        <p className="text-gray-600 text-center mb-10 max-w-2xl mx-auto">
            Отправляем по всей России: пункты выдачи Wildberries и Ozon, Почта России.
            Стоимость и сроки зависят от региона — ниже честная таблица без сюрпризов на кассе.
        </p>

        <section className="mb-10">
            <h2 className="serif text-2xl text-[#1C1917] mb-4">💳 Оплата</h2>
            <div className="bg-white rounded-2xl border border-[#E8E3DD] p-6 space-y-2 text-sm text-gray-700">
                <p>• Онлайн-картой (Мир, Visa, Mastercard) через защищённый платёж Т-Банка.</p>
                <p>• Чек по 54-ФЗ приходит на email сразу после оплаты.</p>
                <p>• Мы не храним данные карт: платёж проходит на стороне банка.</p>
                <p>• Актуальные скидки и акции применяются в корзине автоматически — итоговую сумму вы увидите на этапе оформления.</p>
            </div>
        </section>

        <section className="mb-10">
            <h2 className="serif text-2xl text-[#1C1917] mb-4">🚚 Доставка</h2>
            <div className="space-y-4">
                {DELIVERY_ZONES.map((z) => (
                    <div key={z.id} className="bg-white rounded-2xl border border-[#E8E3DD] p-6">
                        <div className="flex flex-wrap justify-between items-baseline gap-2 mb-2">
                            <p className="font-semibold text-[#1C1917]">{z.label}</p>
                            <p className="text-sm text-[#6B7A6A] font-medium">{z.eta}</p>
                        </div>
                        <p className="text-sm text-gray-700">
                            Бесплатно при заказе от <strong>{z.freeFrom.toLocaleString('ru-RU')} ₽</strong>;
                            при заказе ниже — <strong>{z.fee} ₽</strong> (фиксированно, независимо от веса).
                        </p>
                        {z.id === 'center' && (
                            <p className="text-xs text-gray-500 mt-2">
                                Области: {CENTER_REGIONS.join(', ')} области.
                            </p>
                        )}
                    </div>
                ))}
            </div>
            <p className="text-xs text-gray-500 mt-4">
                Порог бесплатной доставки считается по сумме товаров до скидки.
                Доставка оплачивается отдельно от товаров и добавляется в итог при оформлении.
            </p>
        </section>

        <section className="mb-10">
            <h2 className="serif text-2xl text-[#1C1917] mb-4">🎁 Скидки на заказ</h2>
            <div className="bg-[#F5F0EB] rounded-2xl p-6 text-sm text-gray-700 space-y-2">
                <p>• Мы регулярно запускаем акции — скидка на сумму корзины, скидка за количество товаров, сезонные предложения. Актуальные условия вы увидите автоматически в корзине при оформлении заказа.</p>
                <p>• Например: «10% от 20 000 ₽», «10% за 3 разных товара» — конкретные акции смотрите в баннере на главной и в корзине.</p>
                <p>• Скидки не суммируются — применяется одна, самая выгодная для вас.</p>
                <p>• Вопросы по заказам и оплате: <a href="mailto:sale@puresynergy.ru" className="text-[#6B7A6A] underline font-medium">sale@puresynergy.ru</a> — отвечаем в течение 1–2 часов в рабочее время.</p>
            </div>
        </section>

        <div className="text-center">
            <Link to="/" className="btn-primary inline-block">Перейти в каталог</Link>
        </div>
    </div>
);

export default DeliveryPage;